export default {"src":"/_next/static/media/filter.df2e3489.svg","height":14,"width":21};